import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8 lg:p-10">
      <div className="text-center mb-8 md:mb-10">
        <h3 className="text-2xl md:text-3xl lg:text-4xl font-headline font-bold text-foreground mb-4">
          Frequently Asked Questions
        </h3>
        <p className="text-base md:text-lg text-muted-foreground">
          Everything you need to know about our services
        </p>
      </div>
      <div className="max-w-3xl mx-auto space-y-4">
        {faqs?.map((faq, index) => (
          <div
            key={index}
            className="border border-border rounded-xl overflow-hidden transition-all duration-300 hover:border-primary/50"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex items-center justify-between p-6 text-left bg-card hover:bg-muted transition-colors duration-300"
            >
              <span className="text-base md:text-lg font-headline font-semibold text-foreground pr-4">
                {faq?.question}
              </span>
              <Icon
                name={openIndex === index ? "ChevronUp" : "ChevronDown"}
                size={24}
                className="flex-shrink-0 transition-transform duration-300"
              />
            </button>
            
            <div
              className={`overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'max-h-96' : 'max-h-0'
              }`}
            >
              <div className="p-6 pt-0 text-sm md:text-base text-muted-foreground leading-relaxed">
                {faq?.answer}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;